import { render } from "./past-order.vue?vue&type=template&id=2d07b643&scoped=true"
import script from "./past-order.vue?vue&type=script&lang=js"
export * from "./past-order.vue?vue&type=script&lang=js"

import "./past-order.vue?vue&type=style&index=0&id=2d07b643&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d07b643"]])

export default __exports__